import { Chat } from '@/config'
import { useMemo } from 'react'
import { previewDate } from '@/utils'
import { useChannelPreviewInfo } from 'stream-chat-react'
import { isChatGroup, ChatChannelInstance, useShouldChatRerender, useChatDMUser } from '@packages/chat'

export type UseChatPropsType = {
  channel: ChatChannelInstance
}

export const useChatProps = ({ channel: channelProps = {} as ChatChannelInstance }: UseChatPropsType) => {
  const user = Chat.Store.useUser()

  // To store the first channel value and avoid crashes if channel changes to null
  const channel = useMemo(() => channelProps as ChatChannelInstance, [])
  const { dmUser } = useChatDMUser(channel)

  useShouldChatRerender(channel?.id)
  // Avatar reactivity lives in useChatPreviewAvatar so non-avatar consumers do not
  // rerender on DM image-only updates.
  const { displayTitle } = useChannelPreviewInfo({ channel, overrideImage: '__chat-preview-avatar-handled-separately__' })

  const isGroup = isChatGroup(channel)

  const groupOwner = isGroup && channel?.data?.created_by
  const membersCount = channel?.data?.member_count
  const previewCreatedAt = channel?.data?.created_at
    ? previewDate(channel?.data?.created_at)
    : undefined

  return {
    displayTitle,
    user,
    previewCreatedAt,
    isGroup,
    groupOwner,
    dmUser,
    membersCount,
  }
}
